import { useComputed, useSignal } from '@preact/signals-react'
import Alert from 'react-bootstrap/Alert'

export default function UtgNotMigratedWarning({showWarning}) {
    if (showWarning) {
        return (
            <Alert variant='warning' className='my-3'>
                <Alert.Heading>UTG Schema Version</Alert.Heading>
                The configuration section is designed to work with UTG schemas that have been migrated. This UTG version has not been migrated.
            </Alert>
        )
    }
}